  import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTokenInfo } from "../../../utils/Guard";
import { useNavigate } from "react-router-dom";
import { GetOrganizations } from "../../../store/organization-store/organization-actions";
import { organizationActions } from "../../../store/organization-store/organization-slice";
import { Button } from "primereact/button";
import ABADatatable from "../../../components/ABADataTable/ABADatatable";

const OrganizationsHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getTokenInfo();
  const organizations = useSelector((state) => state.organization.organizations);
  
  useEffect(() => {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("organization.showAll")
    ) {
      dispatch(GetOrganizations(userInfo.Email, true));
    } else if (
      userInfo.Roles !== undefined &&
      !userInfo.Roles.includes("organization.menu")
    ) {
      window.location.href = "/home";
    }
  }, [dispatch, userInfo.Email, userInfo.Roles]);

  const viewDetailHanlder = (val) => {
    navigate(`/organization/detail/${val.id}`);
  };
  const editHanlder = (val) => {
    navigate(`/organization/edit/${val.id}`);
  };
  const createHanlder = () => {
    dispatch(
      organizationActions.setOrganization({
        organization: {
          id: 0,
          
          name: "",
          description: "",
          status: false,
        },
      })
    );
    navigate(`/organization/create`);
  };

  const backHanlder = () => {
    navigate(`/`);
  };
  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("organization.edit")
    ) {
      buttons.push(buttonEdit);
    }
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("organization.view")
    ) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);
  

  const columns = [
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
    },
    {
      field: "identifier",
      header: "RNC",
      filterMatchMode: "contains",
    },

  ];

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "118vh" }}
      >
        <ABADatatable
          width="20%"
          title="Organizaciones"
          values={organizations}
          rows={5}
          rowsPerPageOptions={[5, 10, 20]}
          Columns={columns}
          actions={actions}
          createButton={{
            label: "Agregar",
            onClick: createHanlder,
            permission: "organization.create",
          }}
          backButton={{
            label: "Regresar",
            onClick: backHanlder,
            permission: "goBack",
          }}
        />
      </div>
    </>
  );
};
export default OrganizationsHomePage;
